<p>
  logout works!
</p>
